<p>
  logout works!
</p>
